"use strict";

import axios from "axios";
import router from "@/router";
// import { useRoute, useRouter } from "vue-router";

import { getToken, removeToken } from "@/utils/auth";
import { TOKEN_KEY } from "@/constants/auth";

// const [router, route] = [useRouter(), useRoute()];

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const token = getToken();
let config = {
  baseURL: process.env.VUE_APP_baseURL || process.env.apiUrl || "",
  timeout: 60 * 1000,
  // Timeout
  withCredentials: true,
  // Check cross-site Access-Control
  headers: {}
};
const _axios = axios.create(config);

// 整理参数、获取token等
_axios.interceptors.request.use(function (config) {
  // 如果headers里没有登录信息自动获取
  if (!config.headers[TOKEN_KEY]) {
    const token = getToken();
    config.headers[TOKEN_KEY] = token;
  }
  if (config.method === "post") {
    if (config.data instanceof FormData) {
      config.headers["Content-type"] = "multipart/form-data";
    }
    // if()
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
_axios.interceptors.response.use(function (response) {
  // 响应拦截器
  return response.data;
}, function (error) {
  if (error.status === 401) {
    // showFailToast({
    // 	message: "登录已失效，请重新登录",
    // 	forbidClick: true,
    // });
    // setTimeout(() => {
    // 	removeToken();
    // 	router.replace("/");
    // }, 300);
  }
  if (error.status !== 200) {
    const response = error.response;

    // console.log(error);
    // if (response) {

    // }
    showFailToast({
      message: `请求失败，Code:${error.status}`
    });
  }
  return error.response;
  // return Promise.reject(error.response);
});
Plugin.install = function (Vue, options) {
  window.Vue = Vue;
  window.$axios = _axios;
  Object.defineProperties(Vue, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};
export default Plugin;